import React from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/DraftControlPanel';
import block from 'propmods';

import { getSmartHomeTestingChecklistTexts } from '../../locale/ru/smartHomeTesting';
import Link from '../Link/Link';

import './ReviewChecklist.scss';

const t = i18n(keyset);
interface Props {
    hidden: boolean;
}

const b = block('ReviewChecklist');

const publicRules = t('checklist-public-rules').split('\n');

const hiddenRules = t('checklist-hidden-rules').split('\n');

const ReviewChecklist = (props: Props) => {
    const rules = props.hidden ? hiddenRules : publicRules;

    return (
        <>
            <ul {...b('list')}>
                {rules.map((rule, index) => (
                    <li {...b('item')} key={rule}>
                        {rule}
                        {index === rules.length - 1 ? '.' : ';'}
                    </li>
                ))}
            </ul>
            <div {...b('footer')}>
                <Link to="https://tech.yandex.ru/dialogs/alice/doc/publish-docpage/" target="_blank">
                    {t('checklist-full')}
                </Link>
            </div>
        </>
    );
};

export const SmartHomeReviewChecklist = () => {
    return (
        <ul {...b('list')}>
            {getSmartHomeTestingChecklistTexts().map((rule, i) => (
                <li {...b('item')} key={i}>
                    {rule}
                </li>
            ))}
        </ul>
    );
};

export default ReviewChecklist;
